// Which staff chat thread is open on screen (client-only state). The live hub reads it so a message arriving in the
// open thread is not counted as unread; the thread view sets it while mounted.
import { create } from 'zustand';

interface OpenThreadState {
  openThreadId: string | null;
  setOpenThreadId: (id: string | null) => void;
}

export const useOpenThreadStore = create<OpenThreadState>((set) => ({
  openThreadId: null,
  setOpenThreadId: (openThreadId) => set({ openThreadId }),
}));
